import React, { useEffect, useRef } from 'react';
import { useAppStore } from '../store';

export default function CanvasRenderer() {
  const canvasPhRef = useRef(null);
  const canvasResRef = useRef(null);
  
  const { photo, iaImage } = useAppStore();
  
  // Draw photo layer (hidden when AI result is displayed)
  useEffect(() => {
    const canvas = canvasPhRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * window.devicePixelRatio;
    canvas.height = rect.height * window.devicePixelRatio;
    ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
    
    if (iaImage) {
      ctx.clearRect(0, 0, rect.width, rect.height);
      return;
    }
    
    ctx.fillStyle = '#1E3A52';
    ctx.fillRect(0, 0, rect.width, rect.height);
    
    if (photo) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const scale = Math.min(rect.width / img.width, rect.height / img.height);
        const x = (rect.width - img.width * scale) / 2;
        const y = (rect.height - img.height * scale) / 2;
        ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
      };
      img.src = photo;
    } else {
      ctx.strokeStyle = 'rgba(255,255,255,0.05)';
      ctx.lineWidth = 1;
      const gridSize = 30;
      for (let x = 0; x < rect.width; x += gridSize) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, rect.height);
        ctx.stroke();
      }
      for (let y = 0; y < rect.height; y += gridSize) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(rect.width, y);
        ctx.stroke();
      }
    }
  }, [photo, iaImage]);
  
  // Draw IA result layer
  useEffect(() => {
    const canvas = canvasResRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * window.devicePixelRatio;
    canvas.height = rect.height * window.devicePixelRatio;
    ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
    
    ctx.clearRect(0, 0, rect.width, rect.height);
    
    if (iaImage) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const scale = Math.min(rect.width / img.width, rect.height / img.height);
        const x = (rect.width - img.width * scale) / 2;
        const y = (rect.height - img.height * scale) / 2;
        ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
      };
      img.src = iaImage;
    }
  }, [iaImage]);
  
  return (
    <div className="absolute inset-0">
      <canvas ref={canvasPhRef} className="absolute inset-0 w-full h-full" />
      <canvas ref={canvasResRef} className="absolute inset-0 w-full h-full" />
    </div>
  );
}
